import { tns } from 'tiny-slider';
import SmoothScroll from 'smooth-scroll';
import inView from 'in-view';
import Swal from 'sweetalert2/dist/sweetalert2.min';
import initSlider from "./slider";
import eventBus from "../utils/eventBus";
import Plyr from 'plyr';

const pageScroll = new SmoothScroll();
let didScroll = false;
const plyrControls = `
<div class="plyr__controls">
    <button type="button" class="c-btn c-btn--pill c-btn--pill-small c-btn--pill-filled c-btn--has-icon c-btn--icon-prepend plyr__control plyr__control--fullscreen" data-plyr="fullscreen-exit">
      <span class="c-btn__label">Zurück zum Zeitstrahl</span>
        <svg class="c-btn__icon c-btn__icon--arrow"><use xlink:href="#icon-arrow-left"></use></svg>
      </span>
    </button>
    <button type="button" class="plyr__control" aria-label="Play, {title}" data-plyr="play">
        <svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-pause"></use></svg>
        <svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-play"></use></svg>
        <span class="label--pressed plyr__tooltip" role="tooltip">Pause</span>
        <span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span>
    </button>
    <div class="plyr__time plyr__time--current" aria-label="Current time">00:00</div>
    <div class="plyr__progress">
        <input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" aria-label="Seek">
        <progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress>
        <span role="tooltip" class="plyr__tooltip">00:00</span>
    </div>
    <button type="button" class="plyr__control" aria-label="Mute" data-plyr="mute">
        <svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-muted"></use></svg>
        <svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-volume"></use></svg>
        <span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span>
        <span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span>
    </button>
    <div class="plyr__volume">
        <input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume">
    </div>
    <button type="button" class="plyr__control" data-plyr="fullscreen">
        <svg class="icon--pressed" role="presentation"><use xlink:href="#plyr-exit-fullscreen"></use></svg>
        <svg class="icon--not-pressed" role="presentation"><use xlink:href="#plyr-enter-fullscreen"></use></svg>
        <span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span>
        <span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span>
    </button>
</div>
`;


const timeline = () => {
  const body = document.querySelector('body');
  const timeLines = document.querySelectorAll('.c-timeline');

  if(timeLines) {

    window.addEventListener('scroll', () => didScroll = true);
    setInterval(() => {
      if ( didScroll ) {
        didScroll = false;
      }
    }, 150);

    document.addEventListener('scrollStart', () => {
      body.classList.add('timeline-auto-scroll');
    }, false);

    document.addEventListener('scrollStop', () => {
      body.classList.remove('timeline-auto-scroll');
    }, false);

    document.addEventListener('scrollCancel', () => {
      body.classList.remove('timeline-auto-scroll');
    }, false);


    timeLines.forEach(timeLine => {

      const nav = timeLine.querySelector('.c-timeline__nav');
      const sliderEl = nav.querySelector('.c-timeline__nav-slider');
      const prevBtn = nav.querySelector('.c-timeline__nav-button--prev');
      const nextBtn = nav.querySelector('.c-timeline__nav-button--next');

      let navItemIndex = [];

      const navSlider = tns({
        container: sliderEl,
        items: 5,
        axis: 'vertical',
        center: true,
        mouseDrag: true,
        nav: false,
        loop: false,
        controls: true,
        controlsContainer: false,
        prevButton: prevBtn,
        nextButton: nextBtn,
      });

      // # set default current slide / add scroll slider into new position on nav click

      const sliderInfo = navSlider.getInfo();
      [...sliderInfo.slideItems].forEach((item,index) => {
        navItemIndex.push(item.hash);
        if(index === sliderInfo.index) {
          item.classList.add('is-real-current-slide');
        } else {
          item.classList.remove('is-real-current-slide');
        }
        item.addEventListener('click',() =>{
          navSlider.goTo(index);
        })
      });

      // # scroll timeline into current position / check for autoscroll to prevent double scroll

      navSlider.events.on('indexChanged', function (info, eventName) {
          const autoScroll = body.classList.contains('timeline-auto-scroll');

          [...info.slideItems].forEach((item,index) => {
            if(index === info.index) {
              item.classList.add('is-real-current-slide');
              if(!didScroll && !autoScroll) {
                const anchor = timeLine.querySelector(item.hash);
                pageScroll.animateScroll(anchor);
              }
            } else {
              item.classList.remove('is-real-current-slide');
            }
          });
        }
      );

      // # trigger nav update on section reach

      inView.offset(100);
      inView.threshold(0.5);

      inView('.c-timeline__section').on('enter', element => {
        const autoScroll = body.classList.contains('timeline-auto-scroll');

        // # trigger only on user scroll (prevent trigger on SmoothScroll)
        if(didScroll && !autoScroll) {
          const index = navItemIndex.indexOf('#'+element.id);
          navSlider.goTo(index);
        }
      });


    });
  }

};

timeline();

const timelineCards = () => {
  const cards = document.querySelectorAll('.c-timeline__item');
  if(cards) {
    cards.forEach(card => {

      if(card.classList.contains('c-timeline__item--video')) {

        const player = card.querySelector('.c-timeline__item-video-player');
        const plyr = new Plyr(player, {
          controls: plyrControls,
          hideControls: false,
        });

        plyr.on('ready', (event) => {
          const instance = event.detail.plyr;
          instance.elements.controls.querySelector('[data-plyr="fullscreen-exit"]').addEventListener('click',() => {
            plyr.fullscreen.exit();
          })
        });

        card.addEventListener('click', () => {
          if(!card.classList.contains('c-timeline__item--active')) {
            card.classList.add('c-timeline__item--active');
            plyr.play();
          }
        });
      }

      if(card.classList.contains('c-timeline__item--gallery')) {

        const cardHTML = document.querySelector('#'+card.dataset.modal + ' .content').innerHTML;
        const closeBtn = document.querySelector('#'+card.dataset.modal + ' .close').innerHTML;

        card.addEventListener('click', () => {

          Swal.fire({
            html: cardHTML,
            showConfirmButton: false,
            scrollbarPadding: false,
            grow: 'fullscreen',
            showCloseButton: true,
            closeButtonHtml: closeBtn,
            width: '100%',
            padding: 0,
            didOpen(popup) {
              const slider = popup.querySelectorAll('.c-slider');
              eventBus.emit('nienhuys-swal-opened');
              initSlider(slider, true);
            },
            backdrop: 'rgba(255,255,255,0.9)',
            background: 'transparent',
            customClass : {
              container : 'c-modal--gallery',
              popup : 'c-modal__wrapper',
              htmlContainer : 'c-modal__inner',
              closeButton : 'c-modal__close'
            }
          })

        });
      }
    });
  }
}

timelineCards();
